import type { ReactNode } from "react";

type TopbarProps = {
  /** When omitted (or empty), the title slot is replaced by `leftSlot`
   *  if provided — otherwise the left side is empty. */
  title?: string;
  subtitle?: string;
  /** Custom JSX rendered in the title's place. Ignored when `title`
   *  is also provided (title wins). */
  leftSlot?: ReactNode;
  /** Right-aligned content. Pages own their own filter UI (pickers +
   *  bell) and pass it here so the topbar stays presentation-only. */
  rightSlot?: ReactNode;
};

export function Topbar({ title, subtitle, leftSlot, rightSlot }: TopbarProps) {
  return (
    <div className="topbar">
      {title ? (
        <div>
          <div className="topbar-title">{title}</div>
          {subtitle && <div className="topbar-sub">{subtitle}</div>}
        </div>
      ) : (
        leftSlot ?? <div />
      )}
      {rightSlot ?? null}
    </div>
  );
}
